/**
 * Workflow API client. Mirrors customFieldsApi shape.
 */
import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/workflows`;

export const workflowsApi = {
  listDoctypes: () => axios.get(`${BASE}/doctypes`),
  list: (params = {}) => axios.get(BASE, { params }),
  getActive: (doctype) => axios.get(`${BASE}/active/${doctype}`),
  transitions: (doctype, current_state) =>
    axios.get(`${BASE}/transitions/${doctype}`, { params: { current_state } }),
  get: (wid) => axios.get(`${BASE}/${wid}`),
  create: (payload) => axios.post(BASE, payload),
  update: (wid, payload) => axios.put(`${BASE}/${wid}`, payload),
  delete: (wid) => axios.delete(`${BASE}/${wid}`),
};

export default workflowsApi;
